const FeatureAccessStatusTypeName = "FeatureAccessStatus";
const AccountVerificationStatusTypeName = "AccountVerificationStatus";
const AmlLabelTypeName = "AmlLabel";
const ConnectionTypeTypeName = "ConnectionType";
const GenderTypeName = "Gender";
const EnablementModeTypeName = "EnablementMode";
const LoginStatusTypeName = "LoginStatus";
const KycStatusTypeName = "KycStatus";
const PlayersRelationTypeTypeName = "PlayersRelationType";
const UserStatisticsGameTypeTypeName = "UserStatisticsGameType";
const PaymentOptionTypeName = "PaymentOption";
const PaymentVendorTypeName = "PaymentVendor";
const AccountVerificationTypeTypeName = "AccountVerificationType";
const BulkStatusTypeName = "BulkStatus";
const NoteTypeTypeName = "NoteType";
const WorkspaceTypeName = "Workspace";
const RevenueShareOfferingStatusTypeName = "RevenueShareOfferingStatus";
const GeoCheckStatusTypeName = "GeoCheckStatus";
const GeoCheckEventSourceTypeName = "GeoCheckEventSource";
const GamePlatformTypeName = "GamePlatform";
const TicketStatusTypeName = "TicketStatus";
export {
  AccountVerificationStatusTypeName,
  AccountVerificationTypeTypeName,
  AmlLabelTypeName,
  BulkStatusTypeName,
  ConnectionTypeTypeName,
  EnablementModeTypeName,
  FeatureAccessStatusTypeName,
  GamePlatformTypeName,
  GenderTypeName,
  GeoCheckEventSourceTypeName,
  GeoCheckStatusTypeName,
  KycStatusTypeName,
  LoginStatusTypeName,
  NoteTypeTypeName,
  PaymentOptionTypeName,
  PaymentVendorTypeName,
  PlayersRelationTypeTypeName,
  RevenueShareOfferingStatusTypeName,
  TicketStatusTypeName,
  UserStatisticsGameTypeTypeName,
  WorkspaceTypeName
};
//# sourceMappingURL=constants.js.map
